import { m } from '../paraglide/messages'

const dotColor: Record<string, string> = {
  // lesson statuses
  scheduled:       'text-zinc-900',
  completed:       'text-zinc-900',
  cancelled:       'text-red-600',
  no_show:         'text-red-600',
  // notification statuses
  pending:         'text-zinc-400',
  fired:           'text-zinc-900',
  awaiting_reply:  'text-zinc-400',
  skipped:         'text-zinc-400',
  failed:          'text-red-600',
}

const statusLabel: Record<string, () => string> = {
  waiting:        () => m.status_waiting(),
  scheduled:      () => m.status_scheduled(),
  completed:      () => m.status_completed(),
  cancelled:      () => m.status_cancelled(),
  no_show:        () => m.status_no_show(),
  pending:        () => m.status_pending(),
  fired:          () => m.status_fired(),
  awaiting_reply: () => m.status_awaiting_reply(),
  skipped:        () => m.status_skipped(),
  failed:         () => m.status_failed(),
}

interface StatusBadgeProps {
  status: string
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const color = dotColor[status] ?? 'text-zinc-400'
  const label = statusLabel[status]?.() ?? status

  return (
    <span className="inline-flex items-center gap-1 text-sm text-zinc-900">
      <span className={`${color} leading-none`}>•</span>
      {label}
    </span>
  )
}
